export class UploadFilesHelper {
  static getAllowedImageFileTypes() {
    return ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
  }
}
